// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.course-form-container {
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 20px;
}

.course-form-container h3 {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 1.1rem;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.form-group {
  margin-bottom: 15px;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: flex-start;
  margin-bottom: 15px;
}

.form-row .form-group {
  flex: 1 1 160px;
  margin-bottom: 0;
}

.form-row .checkbox-group {
  flex: 0 0 auto;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  font-size: 0.9rem;
  color: #333;
}

.required-marker {
  color: var(--fleetly-accent-orange);
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.95rem;
}

.form-group input:focus {
  outline: none;
  border-color: var(--fleetly-primary-navy);
}

.form-group input.invalid {
  border-color: var(--fleetly-accent-orange);
  background-color: #fff8f8;
}

.form-group input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.error-message {
  color: var(--fleetly-accent-orange);
  font-size: 0.8rem;
  margin-top: 4px;
}

.form-actions {
  margin-top: 20px;
}

.form-buttons {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}

.cancel-button {
  flex: 1;
  padding: 12px;
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  font-size: 0.95rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background-color 0.2s;
}

.cancel-button:hover {
  background-color: #545b62;
}

.save-button {
  flex: 1;
  padding: 12px;
  background-color: var(--fleetly-primary-navy);
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  font-size: 0.95rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background-color 0.2s;
}

.save-button:hover {
  background-color: var(--fleetly-primary-navy-dark, #15304A);
}

.save-button:disabled {
  background-color: #bbdefb;
  cursor: not-allowed;
}

.button-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255,255,255,0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.form-error {
  margin-top: 15px;
  padding: 10px;
  background-color: #ffebee;
  border-radius: 4px;
  color: var(--fleetly-accent-orange);
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
}

.course-view-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.location {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #666;
  font-size: 0.85rem;
  margin-top: 5px;
}

.waypoints-count {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #666;
  font-size: 0.85rem;
}

/* ===== Mobile Responsive Fixes ===== */

/* Course Sequence - Make responsive for small screens */
.config-section h3 {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap; /* Allow wrapping on small screens */
}

/* Make Course Sequence full width on mobile */
@media (max-width: 768px) {
  .config-section h3 {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .config-section h3 > span:last-child {
    /* Course sequence value */
    width: 100%;
    margin-top: 4px;
    display: block;
  }
}

/* ===== Checkbox Improvements - Better visibility ===== */

/* Enhance checkbox visibility with custom styling */
.checkbox-group {
  position: relative;
}

.checkbox-group label {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  padding-left: 32px; /* Space for custom checkbox */
  min-height: 24px;
  user-select: none;
}

/* Hide default checkbox */
.checkbox-group input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  width: 0;
  height: 0;
}

/* Custom checkbox */
.checkbox-group label::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 22px;
  width: 22px;
  background-color: white;
  border: 2px solid #ddd;
  border-radius: 4px;
  transition: all 0.2s ease;
}

/* Hover effect */
.checkbox-group label:hover::before {
  border-color: var(--fleetly-primary-navy);
  box-shadow: 0 0 0 3px rgba(27, 58, 87, 0.1);
}

/* Checked state - background color */
.checkbox-group input[type="checkbox"]:checked + span::before,
.checkbox-group label:has(input[type="checkbox"]:checked)::before {
  background-color: var(--fleetly-primary-navy);
  border-color: var(--fleetly-primary-navy);
}

/* Checkmark icon */
.checkbox-group label::after {
  content: "";
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
  width: 6px;
  height: 11px;
  border: solid white;
  border-width: 0 2px 2px 0;
  opacity: 0;
  transition: opacity 0.2s ease;
}

/* Show checkmark when checked */
.checkbox-group input[type="checkbox"]:checked ~ span::after,
.checkbox-group label:has(input[type="checkbox"]:checked)::after {
  opacity: 1;
}

/* Disabled state */
.checkbox-group input[type="checkbox"]:disabled + span::before,
.checkbox-group label:has(input[type="checkbox"]:disabled)::before {
  background-color: #f5f5f5;
  border-color: #e0e0e0;
  cursor: not-allowed;
}

.checkbox-group label:has(input[type="checkbox"]:disabled) {
  cursor: not-allowed;
  opacity: 0.6;
}

/* Label text styling */
.checkbox-group label span {
  font-weight: 500;
  color: #333;
  font-size: 0.95rem;
  line-height: 1.4;
}

/* Form hint styling */
.form-hint {
  font-size: 0.8rem;
  color: #666;
  margin-top: 4px;
  margin-left: 32px; /* Align with checkbox label text */
  line-height: 1.3;
}

/* Mobile adjustments for checkboxes */
@media (max-width: 768px) {
  .checkbox-group label {
    padding-left: 36px; /* Larger touch target */
    min-height: 32px;
  }
  
  .checkbox-group label::before {
    height: 26px;
    width: 26px;
  }
  
  .checkbox-group label::after {
    left: 9px;
    width: 7px;
    height: 13px;
  }
  
  .checkbox-group label span {
    font-size: 1rem;
  }
  
  .form-hint {
    margin-left: 36px;
    font-size: 0.85rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/CourseForm.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,6CAA6C;EAC7C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;AACpB;;AAEA,wCAAwC;;AAExC,wDAAwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe,EAAE,oCAAoC;AACvD;;AAEA,8CAA8C;AAC9C;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,eAAe;IACf,cAAc;EAChB;AACF;;AAEA,0DAA0D;;AAE1D,oDAAoD;AACpD;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB,EAAE,8BAA8B;EAClD,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,QAAQ;EACR,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA,qCAAqC;AACrC;;EAEE,6CAA6C;EAC7C,yCAAyC;AAC3C;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,yCAAyC;EACzC,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,6BAA6B;AAC/B;;AAEA,gCAAgC;AAChC;;EAEE,UAAU;AACZ;;AAEA,mBAAmB;AACnB;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,iBAAiB,EAAE,mCAAmC;EACtD,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE;IACE,kBAAkB,EAAE,wBAAwB;IAC5C,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,SAAS;IACT,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":[".course-form-container {\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 15px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  margin-bottom: 20px;\n}\n\n.course-form-container h3 {\n  margin-top: 0;\n  margin-bottom: 15px;\n  font-size: 1.1rem;\n  color: #333;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 10px;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  align-items: flex-start;\n  margin-bottom: 15px;\n}\n\n.form-row .form-group {\n  flex: 1 1 160px;\n  margin-bottom: 0;\n}\n\n.form-row .checkbox-group {\n  flex: 0 0 auto;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 500;\n  font-size: 0.9rem;\n  color: #333;\n}\n\n.required-marker {\n  color: var(--fleetly-accent-orange);\n}\n\n.form-group input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.95rem;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: var(--fleetly-primary-navy);\n}\n\n.form-group input.invalid {\n  border-color: var(--fleetly-accent-orange);\n  background-color: #fff8f8;\n}\n\n.form-group input:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.error-message {\n  color: var(--fleetly-accent-orange);\n  font-size: 0.8rem;\n  margin-top: 4px;\n}\n\n.form-actions {\n  margin-top: 20px;\n}\n\n.form-buttons {\n  display: flex;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.cancel-button {\n  flex: 1;\n  padding: 12px;\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-weight: 500;\n  font-size: 0.95rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: background-color 0.2s;\n}\n\n.cancel-button:hover {\n  background-color: #545b62;\n}\n\n.save-button {\n  flex: 1;\n  padding: 12px;\n  background-color: var(--fleetly-primary-navy);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-weight: 500;\n  font-size: 0.95rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: background-color 0.2s;\n}\n\n.save-button:hover {\n  background-color: var(--fleetly-primary-navy-dark, #15304A);\n}\n\n.save-button:disabled {\n  background-color: #bbdefb;\n  cursor: not-allowed;\n}\n\n.button-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255,255,255,0.3);\n  border-radius: 50%;\n  border-top-color: #fff;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.form-error {\n  margin-top: 15px;\n  padding: 10px;\n  background-color: #ffebee;\n  border-radius: 4px;\n  color: var(--fleetly-accent-orange);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.9rem;\n}\n\n.course-view-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.location {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  color: #666;\n  font-size: 0.85rem;\n  margin-top: 5px;\n}\n\n.waypoints-count {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  color: #666;\n  font-size: 0.85rem;\n}\n\n/* ===== Mobile Responsive Fixes ===== */\n\n/* Course Sequence - Make responsive for small screens */\n.config-section h3 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap; /* Allow wrapping on small screens */\n}\n\n/* Make Course Sequence full width on mobile */\n@media (max-width: 768px) {\n  .config-section h3 {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .config-section h3 > span:last-child {\n    /* Course sequence value */\n    width: 100%;\n    margin-top: 4px;\n    display: block;\n  }\n}\n\n/* ===== Checkbox Improvements - Better visibility ===== */\n\n/* Enhance checkbox visibility with custom styling */\n.checkbox-group {\n  position: relative;\n}\n\n.checkbox-group label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n  padding-left: 32px; /* Space for custom checkbox */\n  min-height: 24px;\n  user-select: none;\n}\n\n/* Hide default checkbox */\n.checkbox-group input[type=\"checkbox\"] {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  width: 0;\n  height: 0;\n}\n\n/* Custom checkbox */\n.checkbox-group label::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  height: 22px;\n  width: 22px;\n  background-color: white;\n  border: 2px solid #ddd;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n/* Hover effect */\n.checkbox-group label:hover::before {\n  border-color: var(--fleetly-primary-navy);\n  box-shadow: 0 0 0 3px rgba(27, 58, 87, 0.1);\n}\n\n/* Checked state - background color */\n.checkbox-group input[type=\"checkbox\"]:checked + span::before,\n.checkbox-group label:has(input[type=\"checkbox\"]:checked)::before {\n  background-color: var(--fleetly-primary-navy);\n  border-color: var(--fleetly-primary-navy);\n}\n\n/* Checkmark icon */\n.checkbox-group label::after {\n  content: \"\";\n  position: absolute;\n  left: 8px;\n  top: 50%;\n  transform: translateY(-50%) rotate(45deg);\n  width: 6px;\n  height: 11px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n/* Show checkmark when checked */\n.checkbox-group input[type=\"checkbox\"]:checked ~ span::after,\n.checkbox-group label:has(input[type=\"checkbox\"]:checked)::after {\n  opacity: 1;\n}\n\n/* Disabled state */\n.checkbox-group input[type=\"checkbox\"]:disabled + span::before,\n.checkbox-group label:has(input[type=\"checkbox\"]:disabled)::before {\n  background-color: #f5f5f5;\n  border-color: #e0e0e0;\n  cursor: not-allowed;\n}\n\n.checkbox-group label:has(input[type=\"checkbox\"]:disabled) {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* Label text styling */\n.checkbox-group label span {\n  font-weight: 500;\n  color: #333;\n  font-size: 0.95rem;\n  line-height: 1.4;\n}\n\n/* Form hint styling */\n.form-hint {\n  font-size: 0.8rem;\n  color: #666;\n  margin-top: 4px;\n  margin-left: 32px; /* Align with checkbox label text */\n  line-height: 1.3;\n}\n\n/* Mobile adjustments for checkboxes */\n@media (max-width: 768px) {\n  .checkbox-group label {\n    padding-left: 36px; /* Larger touch target */\n    min-height: 32px;\n  }\n  \n  .checkbox-group label::before {\n    height: 26px;\n    width: 26px;\n  }\n  \n  .checkbox-group label::after {\n    left: 9px;\n    width: 7px;\n    height: 13px;\n  }\n  \n  .checkbox-group label span {\n    font-size: 1rem;\n  }\n  \n  .form-hint {\n    margin-left: 36px;\n    font-size: 0.85rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
